import IService from "@api/iService";
import {IShortNews} from "@interfaces/user/shortNews";

export default class NewsService extends IService {

    async getNews() {
        return await this.getAndThrowApi<IShortNews[]>('/api/user/shortnews/');
    }

}